<template>
  <div id="park-list" class="park-list">
    <div>
      <el-form :model="search" label-width="100px" ref="search">
        <el-row>
          <el-col :span="8">
            <el-form-item label="关键词查询" prop="name">
              <el-input
                v-model="search.name"
                placeholder="请输入产业聚集区名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="行政区划" prop="xzqh">
              <el-cascader
                v-model="search.xzqh"
                :options="xzqhList"
                :props="{ checkStrictly: true }"
                clearable
                placeholder="请选择"
                style="width: 100%"
                popper-class="theder"
              ></el-cascader>
              <!--
                @change="changeRegion" -->
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-left: 10px">
            <div>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="searchList"
                >查询
              </el-button>
              <el-button
                type="info"
                icon="el-icon-refresh-right"
                @click="refreshList"
              >
                清除
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="park-list-table-no-top">
      <div class="comparison-switch">
        <el-switch v-model="isComparison" active-text="对比"></el-switch>
      </div>
      <span>未找到地块？</span
      ><span class="font-red" @click="releaseNeed">发布需求！</span>
    </div>

    <div id="badge-box" class="badge-box" v-if="isComparison">
      <el-badge
        :value="contrastList.length"
        class="item"
        style="font-size: 1.55rem; cursor: pointer"
      >
        <img
          class="badge-img"
          src="@/assets/images/common/list.png"
          @click="detailedListsShow"
        />
      </el-badge>
    </div>
    <div
      class="table-box"
      v-if="tableList.length || loading"
      v-loading="loading"
    >
      <div
        class="card-base"
        v-for="(item, index) in tableList"
        :key="index"
        v-show="tableList.length"
      >
        <el-card :body-style="{ padding: '2px', width: '245px' }">
          <div class="card-base-box" @click="goDetails(item)">
            <img
              :src="
                item.imgUrl
                  ? item.imgUrl
                  : require('../../assets/images/home/land.png')
              "
              height="162px"
              width="245px"
              alt=""
            />
          </div>
          <div>
            <h3>{{ item.name }}</h3>
            <el-tag class="card-info">{{ item.parkLevelName }}</el-tag>
            <br /><el-tag class="card-info" type="info"
              >{{ item.actualAreaActual }}公顷</el-tag
            >
            <div
              :id="index == 0 ? 'park-list-table-checkbox' : ''"
              class="park-list-table-checkbox"
              @click.stop=""
              v-if="isComparison"
            >
              <el-checkbox
                v-model="item.checked"
                size="medium"
                :true-label="1"
                :false-label="0"
                @change="changeChecked($event, item)"
              ></el-checkbox>
            </div>
            <!--展示浏览量-->
            <el-tooltip content="浏览量60" placement="left" :open-delay="1000">
              <div class="pageView" v-if="!isComparison">
                <el-progress
                  :percentage="60"
                  :format="progressFormat"
                ></el-progress>
              </div>
            </el-tooltip>
          </div>
        </el-card>
      </div>
    </div>

    <div class="park-list-table-no" v-show="!tableList.length && !loading">
      <div class="park-list-table-no-c">
        <div class="park-list-table-no-c-img">
          <img src="../../assets/images/common/2.png" alt="" />
        </div>
        <div class="park-list-table-no-c-span">
          抱歉，没有找到符合条件的结果，您可以去
        </div>
        <div class="park-list-table-no-c-btn" @click="releaseNeed">
          发布需求
        </div>
      </div>
    </div>
    <div class="page-box" v-show="tableList.length">
      <el-pagination
        :current-page="search.current"
        :page-sizes="[10, 20, 40, 80]"
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="search.size"
        layout=" prev, pager, next,total, jumper "
        :total="total"
      ></el-pagination>
    </div>
    <!-- 对比清单 -->
    <div class="contrast-list" v-show="isDetailedList">
      <detailed-list
        :contrast-list="contrastList"
        @callBack="callBack"
      ></detailed-list>
    </div>
  </div>
</template>
<script>
import { getXzqhList } from "@/api/common";
import { getParkPage } from "@/api/setting/investment";
import card from "./components/card.vue";
import detailedList from "./components/detailedList";
import Driver from "driver.js";

export default {
  name: "park-list",
  components: { card, detailedList },
  data() {
    return {
      search: {
        name: "",
        xzqh: [],
        county: "",
        type: "",
        size: 10,
        current: 1,
      },
      total: 0,
      tableList: [
        {
          name: "高新科技产业聚集区",
          parkLevelName: "产业聚集区",
          actualAreaActual: 0.51,
          checked: false,
        },
        {
          name: "工业产业聚集区",
          parkLevelName: "产业聚集区",
          actualAreaActual: 0.51,
          checked: false,
        },
      ],
      xzqhList: [],
      loading: false,
      contrastList: [],
      isDetailedList: false,
      isComparison: false,
    };
  },

  mounted() {
    this.getXzqh();
    //this.getList();
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "1405px";
  },
  methods: {
    // 加载功能引导
    guide() {
      let driver = new Driver();
      driver.defineSteps([
        {
          element: "#park-list-table-checkbox",
          popover: {
            title: "第一步：勾选园区，勾选两个以上",
            description: "需要勾选两个以上的园区才可以进行对比。",
            position: "left",
            doneBtnText: "确定",
            closeBtnText: "关闭",
            nextBtnText: "下一步",
            prevBtnText: "上一步",
          },
        },
        {
          element: "#badge-box",
          popover: {
            title: "第二步：点击对比",
            description:
              "勾选完园区后，点击这里，会弹出已选择的园区的列表，再点击对比按钮就可以开始对比啦。",
            position: "bottom",
            doneBtnText: "确定",
            closeBtnText: "关闭",
            nextBtnText: "下一步",
            prevBtnText: "上一步",
          },
        },
      ]);
      driver.start();
    },
    callBack() {
      this.isDetailedList = false;
    },
    //获取行政区划
    getXzqh() {
      getXzqhList().then((res) => {
        if (res.data.success) {
          this.xzqhList = res.data.data;
        }
      });
    },

    //添加需求
    releaseNeed() {
      this.$router.push({
        path: "/land/releaseNeed",
      });
    },
    searchList() {
      if (this.search.xzqh.length) {
        this.search.county = this.search.xzqh[this.search.xzqh.length - 1];
      }
      this.search.current = 1;
      this.getList();
    },

    //刷新
    refreshList() {
      this.$refs["search"].resetFields();
      this.search.xzqh = [];
      this.getList();
    },
    //切换页码
    handleCurrentChange(val) {
      this.search.current = val;
      this.getList();
    },

    //切换页条数
    handleSizeChange(val) {
      this.search.size = val;
      this.getList();
    },

    getList() {
      this.loading = true;
      getParkPage(this.search).then((res) => {
        if (res.data.success) {
          this.total = res.data.data.total;
          let list = res.data.data.records;
          list.forEach((item) => {
            if (item.pronounceImages) {
              let imgUrl =
                item.pronounceImages.length > 0
                  ? systemConfig.imgServer +
                    systemConfig.imgApi +
                    item.pronounceImages[0].filePath
                  : null;
              this.$set(item, "imgUrl", imgUrl);
            }
            if (item.pronounceVideos && item.pronounceVideos.length) {
              item.pronounceVideos.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "thumbnailSrc",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.thumbnail
                );
              });
            }
            if (item.pronounceImages && item.pronounceImages.length) {
              item.pronounceImages.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "url",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.filePath
                );
              });
            }
            this.$set(item, "checked", 0);
            this.contrastList.forEach((cItem) => {
              if (item.id == cItem) {
                item.checked = 1;
              }
            });
          });

          this.tableList = list;
          this.loading = false;
        } else {
          this.$message.error("查询失败");
          this.loading = false;
        }
      });
    },
    changeChecked(e, data) {
      if (e) {
        this.contrastList.push({ id: data.id, name: data.name });
      } else {
        let index = this.contrastList.findIndex((item) => item.id == data.id);
        this.contrastList.splice(index, 1);
      }
    },
    detailedListsShow() {
      if (!this.contrastList.length) {
        this.$confirm("您选择的园区为空，是否需要功能引导？").then(() => {
          this.guide();
        });
      } else if (this.contrastList.length < 2) {
        this.$message.warning("请选择至少两个园区进行对比！");
      } else {
        this.isDetailedList = true;
      }
    },
    // 跳转到详情
    goDetails(item) {
      console.log("跳转");
      this.$router.push({ path: "/industryDetail", query: { id: item.id } });
    },
    progressFormat(p) {
      return "" + p;
    },
  },
  destroyed() {
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "";
  },
  // 缓存组件进如时
  activated() {
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "1405px";
  },
  // 缓存组件离开时
  deactivated() {
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "";
  },
};
</script>
<style scoped>
.park-list {
  /*height: 100%;*/
  width: calc(245px * 5 + 10px * 11);
  margin: 0 auto;
  background: #fff;
  padding: 10px 35px;
  position: relative;
}

/* .search-box {
  height: 46px;
  width: 100%;
} */
.search-btn {
  display: flex;
  justify-content: flex-end;
}

.badge-box {
  position: absolute;
  top: 100px;
  right: -66px;
}

.badge-img {
  width: 60px;
}

.table-box {
  height: calc(100% - 137px);
}

.park-list-table {
  padding: 40px 0;
  border-bottom: 1px solid #c7c3c3;
  display: flex;
}

.park-list-table-checkbox {
  width: 30px;
  position: absolute;
  right: 7px;
  bottom: 18px;
}

::v-deep .el-checkbox__inner {
  width: 23px;
  height: 23px;
  border: 1px solid #626262;
}

.park-list-table-card {
  width: calc(100% - 50px);
}

::v-deep .el-checkbox__inner::after {
  height: 12px;
  width: 6px;
  top: 2px;
  left: 8px;
}

.park-list-table:hover {
  background: #f9f8f8;
}

.park-list-table:active {
  background-color: #00000010;
}

.page-box {
  margin: 10px 0;
  display: flex;
  justify-content: center;
}

::v-deep .page-box .el-pager li {
  border: 1px solid #409eff;
}

::v-deep .el-pagination button:disabled {
  color: #fff;
  background: #409eff;
}

::v-deep .el-pagination .btn-prev {
  margin: 0 10px;
  padding-right: 8px;
}

::v-deep .el-pagination .btn-next {
  padding-left: 8px;
  margin: 0 10px;
}

::v-deep .el-pager li {
  padding: 0;
  margin: 0 4px;
}

.font-red {
  color: red;
  cursor: pointer;
  padding-right: 30px;
}

.park-list-table-no {
  margin-top: 10px;
  width: 100%;
}

.park-list-table-no-top {
  text-align: right;
  border-bottom: 1px solid #c7c3c3;
  font-size: 0.8rem;
  font-weight: 600;
  height: 33px;
  line-height: 33px;
  position: relative;
}

.comparison-switch {
  display: inline-block;
  position: absolute;
  left: 20px;
}

.park-list-table-no-c {
  width: 300px;
  margin: 100px auto 50px;
}

.park-list-table-no-c-img {
  width: 100%;
}

.park-list-table-no-c-img > img {
  width: 100%;
}

.park-list-table-no-c-span {
  margin: 0 auto;
  width: 50%;
  text-align: center;
  font-size: 0.75rem;
  color: #c7c3c3;
}

.park-list-table-no-c-btn {
  font-size: 0.85rem;
  width: 120px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  margin: 20px auto;
  background: #1a6ec2;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
}

.contrast-list {
  position: fixed;
  top: 315px;
  right: 30px;
}

>>> .table-box .el-card {
  width: 245px;
  display: inline-block;
  margin: 10px 10px;
  border-radius: 10px;
  border-top-left-radius: 15px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.card-info {
  margin: 2px 2px;
  font-size: 0.95rem;
}

.card-base {
  display: inline-block;
  position: relative;
}

.card-base-box {
  cursor: pointer;
}

.card-title {
  margin: 7px 10px;
  font-size: 1.05rem;
  font-weight: bold;
  display: inline-block;
}

.pageView {
  width: 100px;
  position: absolute;
  right: -30px;
  bottom: 25px;
}

>>> .pageView .el-progress__text {
  color: #bfbfbf;
  margin: -13px 8px 8px -15px;
}
</style>

